import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

/**
 * Controller component to update map view when selection changes
 * @param {Object} props - Component props
 * @param {Array} props.center - Center coordinates [lat, lng]
 * @param {number} props.zoom - Zoom level
 */
const MapController = ({ center, zoom }) => {
  const map = useMap();
  
  useEffect(() => {
    if (center && zoom) {
      map.setView(center, zoom, { animate: true });
    }
  }, [center, zoom, map]);
  
  return null;
};

export default MapController;